module.exports = __webpack_public_path__ + "img/45.e5d4c645.jpg";